export {};

const input = $.find('.js-mob-readonly');

innerWatch()

$(window).on('resize', function() {
    innerWatch()
});

function innerWatch() {
    if (innerWidth < 768) {
        $(input).prop('readonly', true)
    } else {
        $(input).prop('readonly', false)
    }
};



// WEBPACK FOOTER //
// ./js/main/module/readonly.js